import * as React from 'react';

import * as styles from './ServiceItem.css';
import { ICONS } from './constants';

interface IServiceItemProps {
  icon: keyof typeof ICONS;
  href: string;
  target?: string;
  onClick?(): void;
  children: React.ReactNode;
}

export const ServiceItem: React.FC<IServiceItemProps> = ({ icon, href, target, children, onClick }) => {
  return (
    <li className={styles['container']}>
      <a href={href} target={target} onClick={onClick}>
        <div className={styles['icon']} style={{ backgroundImage: `url("${ICONS[icon]}")` }} />
        {children}
      </a>
    </li>
  );
};
